// Meta Pixel helper

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '1534932801636605'

let initialized = false

function loadPixelScript() {
  if (typeof window === 'undefined') return
  if (window.fbq)
    return // Standard Meta Pixel snippet (function form)
    /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (initialized) return
  loadPixelScript()
  if (window.fbq) {
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }
  initialized = true
}

export function trackMetaEvent(
  eventName: string,
  params?: Record<string, any>,
) {
  if (typeof window === 'undefined') return
  if (!window.fbq) return
  if (params) {
    window.fbq('track', eventName, params)
  } else {
    window.fbq('track', eventName)
  }
}
